import environmentConfig from "environmentConfig";
import { EntityType } from "features/common/types";

export const assetUrlLookup: Record<EntityType, string> = {
  [EntityType.Video]: `${environmentConfig.apUrl}/content/assets/videos`,
  [EntityType.EmbeddedVideo]: `${environmentConfig.apUrl}/content/assets/embedded-videos`,
  [EntityType.Assessment]: `${environmentConfig.apUrl}/content/assets/assessments`,
  [EntityType.Survey]: `${environmentConfig.apUrl}/content/assets/surveys`,
  [EntityType.Pdf]: `${environmentConfig.apUrl}/content/assets/pdfs`,
  [EntityType.Event]: `${environmentConfig.apUrl}/content/assets/events`,
  [EntityType.Flow]: `${environmentConfig.apUrl}/content/flows`,
  [EntityType.Email]: `${environmentConfig.apUrl}/content/communications`,
  [EntityType.Message]: `${environmentConfig.apUrl}/content/communications`,
  [EntityType.Group]: `${environmentConfig.apUrl}/people/groups`,
  [EntityType.UpcomingEvent]: `${environmentConfig.apUrl}/content/assets/events`,
  [EntityType.Asset]: `${environmentConfig.apUrl}/content/assets`,
  [EntityType.Html]: `${environmentConfig.apUrl}/content/assets`,
};

export const getIndividualAssetUrl = (entityType: EntityType, assetId: number) => {
  return `${assetUrlLookup[entityType]}/${assetId}`;
};
